export const DesignerDataRegistryWindowUserSettingsKey = 'designer-data-registry-window';
